module.exports = __webpack_public_path__ + "./docs/img/vox-android.9ac5b63a0c14e22f3abeebb62b8e3621.svg";